import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDebtInformation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M46.3469 43.5566L53.8911 51.1008",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.7998 40.884C44.7998 43.8195 42.4201 46.1992 39.4846 46.1992L16.5151 46.1992C13.5795 46.1992 11.1998 43.8195 11.1998 40.884L11.1998 5.31448C11.1998 2.37895 13.5795 -0.000777335 16.5151 -0.000777079L39.4846 -0.000775071C42.4201 -0.000774814 44.7998 2.37894 44.7998 5.31448L44.7998 40.884Z",
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.2851 54.2586L7.63073 54.2586C5.15602 54.2586 3.14987 52.2524 3.14987 49.7777L3.14988 12.4444C3.14988 9.9697 5.15603 7.96354 7.63074 7.96354L35.2851 7.96355C37.7598 7.96355 39.7659 9.9697 39.7659 12.4444L39.7659 49.7777C39.7659 52.2524 37.7598 54.2586 35.2851 54.2586Z",
			stroke: "#031839",
			strokeWidth: 2.1
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 38.0504,
			cy: 35.9523,
			r: 11.3944,
			fill: "white",
			stroke: "#031839",
			strokeWidth: 2.1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41 31L35 41",
			stroke: "#031839",
			strokeWidth: 1.9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 35,
			cy: 33,
			r: 1.25,
			stroke: "#031839",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 41,
			cy: 39,
			r: 1.25,
			stroke: "#031839",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.58 14.9C20.8 14.9 20.9767 14.9733 21.11 15.12C21.25 15.26 21.32 15.4433 21.32 15.67V21.28C21.32 21.5133 21.25 21.7033 21.11 21.85C20.9767 21.99 20.8 22.06 20.58 22.06C20.34 22.06 20.1467 21.9733 20 21.8L16.65 17.51V21.28C16.65 21.5133 16.5833 21.7033 16.45 21.85C16.3233 21.99 16.15 22.06 15.93 22.06C15.71 22.06 15.5333 21.99 15.4 21.85C15.2667 21.7033 15.2 21.5133 15.2 21.28V15.67C15.2 15.4433 15.2667 15.26 15.4 15.12C15.54 14.9733 15.72 14.9 15.94 14.9C16.1867 14.9 16.3767 14.9867 16.51 15.16L19.86 19.42V15.67C19.86 15.4433 19.9267 15.26 20.06 15.12C20.1933 14.9733 20.3667 14.9 20.58 14.9ZM28.1695 18.11C28.3562 18.11 28.5029 18.1633 28.6095 18.27C28.7229 18.37 28.7795 18.51 28.7795 18.69V20.64C28.7795 20.9067 28.7562 21.1133 28.7095 21.26C28.6695 21.4067 28.5962 21.5233 28.4895 21.61C28.3829 21.6967 28.2229 21.77 28.0095 21.83C27.7495 21.91 27.4495 21.9733 27.1095 22.02C26.7762 22.0667 26.4595 22.09 26.1595 22.09C25.4129 22.09 24.7662 21.9467 24.2195 21.66C23.6729 21.3667 23.2529 20.95 22.9595 20.41C22.6662 19.8633 22.5195 19.2167 22.5195 18.47C22.5195 17.7367 22.6629 17.1 22.9495 16.56C23.2429 16.0133 23.6595 15.5933 24.1995 15.3C24.7395 15.0067 25.3695 14.86 26.0895 14.86C27.0162 14.86 27.7829 15.1 28.3895 15.58C28.4895 15.66 28.5595 15.74 28.5995 15.82C28.6395 15.9 28.6595 16 28.6595 16.12C28.6595 16.2933 28.6095 16.4433 28.5095 16.57C28.4162 16.69 28.3029 16.75 28.1695 16.75C28.0829 16.75 28.0029 16.7367 27.9295 16.71C27.8629 16.6833 27.7795 16.64 27.6795 16.58C27.3995 16.4067 27.1429 16.2833 26.9095 16.21C26.6762 16.1367 26.4195 16.1 26.1395 16.1C24.7795 16.1 24.0995 16.89 24.0995 18.47C24.0995 19.2833 24.2762 19.89 24.6295 20.29C24.9829 20.69 25.5162 20.89 26.2295 20.89C26.6162 20.89 26.9995 20.84 27.3795 20.74V19.19H26.4595C26.2662 19.19 26.1162 19.1433 26.0095 19.05C25.9029 18.9567 25.8495 18.8233 25.8495 18.65C25.8495 18.4767 25.9029 18.3433 26.0095 18.25C26.1162 18.1567 26.2662 18.11 26.4595 18.11H28.1695Z",
			fill: "#031839"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 36H23",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 32H23",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 28H23",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 40H18.5H21",
			stroke: "#031839",
			strokeWidth: 2.1,
			strokeLinecap: "round"
		})
	]
});
export default SvgDebtInformation;
